(function ($) {
	// staff shuffle
	$(".p-case__filter li").on("click", function () {
		var $this = $(this),
			$grid = $(".p-case__list");

		$(".p-case__filter li.active").removeClass("active");
		$this.addClass("active");
		$grid.shuffle($this.data("group"));
	});

	$(".p-case__list").shuffle({
		group: "all",
		speed: 700,
		easing: "ease-in-out",
		isCentered: true,
	});

	$("#grid").shuffle("shuffle", function ($el, shuffle) {
		return $el.data("title").length < 10;
	});
})(jQuery);
